<template>
  <div>
    <modal-cadastro-questao ref="modalCadastroQuestao"
                            :professores="professores"
                            :modalidades="modalidades"
                            :fontes="fontes"
                            :publicoAlvo="publicoAlvo"
                            :cursos="cursos"
                            :modulos="modulos"
                            :licoes="licoes"
                            :questao-edicao="questaoEdicao"
                            :visualizar="visualizacao"
                            @questaoSalva="buscarQuestoes" />

    <modal-cadastro-simulado ref="modalCadastroSimulado"
                        :modalidades="modalidades"
                        :fontes="fontes"
                        :cursos="cursos"
                        :tipo-simulados="tipoSimulados"
                        :publico-alvo="publicoAlvo"
                        :questao-edicao="questaoEdicao"
                        :questoes-selecionadas="questoesSelecionadas"
                        @simuladoSalva="buscarQuestoes" />

    <modal-associa-questao ref="modalTopicoQuestao"
                        :cursos="cursos"
                        :modulos="modulos"
                        :licoes="licoes"
                        :questoes-selecionadas="questoesSelecionadas"
                        @questoesAssociadas="buscarQuestoes" />

    <modal-importacao-questoes ref="modalImportacaoQuestoes" />

    <div class="tab-pane fade show active" id="pills-questoes" role="tabpanel" aria-labelledby="pills-questoes-tab">
      <div>
        <a v-if="perfil.isAdmin || perfil.isAdminJaleko || perfil.isEditor" href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="modalCadastrarQuestao()"><i class="fas fa-plus"></i> Adicionar questão</a>&#32;
        <a v-if="perfil.isAdmin || perfil.isAdminJaleko || perfil.isEditor" href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="modalImportarQuestoes()"><i class="fas fa-file-import"></i> Importar lista</a>&#32;
        <b-link v-b-toggle.collapse-filter class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
        <div class="dropdown btn-acoes mb-2 mb-md-0 d-inline-block">
          <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)" @click="modalCadastrarSimulado()">Criar simulado</a>
            <div class="dropdown-divider" v-if="false"></div>
            <a class="dropdown-item" href="#" v-if="false">Criar quiz</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript:void(0)" @click="modalAssociarQuestao()">Adicionar à lição</a>
          </div>
        </div>
      </div>
    </div>

    <b-collapse id="collapse-filter" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarQuestoes">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select class="form-control" v-model="filtro.tipo">
                      <option value="1">Múltipla escolha</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="nome">Nome</label>
                    <input type="text" class="form-control" id="nome" placeholder="Nome da questão" v-model="filtro.nome" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="ano">Ano</label>
                    <input type="text" class="form-control" maxlength="4" id="ano" placeholder="Ano" v-model="filtro.ano" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="professor">Professor</label>
                    <select class="form-control" id="professor" v-model="filtro.professor">
                      <option value="">Selecione</option>
                      <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Enunciado</label>
                    <input type="text" class="form-control" placeholder="Enunciado da questão" v-model="filtro.enunciado" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>1ª opção de resposta</label>
                    <input type="text" class="form-control" placeholder="Descrição da opção" v-model="filtro.resposta1" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Comentário</label>
                    <input type="text" class="form-control" placeholder="Comentário da questão" v-model="filtro.comentario" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Curso</label>
                    <input type="text" class="form-control" placeholder="Nome do curso" v-model="filtro.curso" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Módulo</label>
                    <input type="text" class="form-control" placeholder="Nome do módulo" v-model="filtro.modulo" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Lição</label>
                    <input type="text" class="form-control" placeholder="Nome da Lição" v-model="filtro.licao" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="questoes.length">
      <table class="table" ref="resultadoTabelaQuestoes">
        <thead>
          <tr>
            <th></th>
            <th>Nome</th>
            <th>Enunciado</th>
            <th>Professor</th>
            <th>Curso</th>
            <th>Módulo</th>
            <th>Lição</th>
            <th>Data de Cadastro</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="questao in questoes" v-bind:key="questao.id">
            <td><input type="checkbox" @click="alteraSelecionada(questao)"  v-model="questoesSelecionadas" :value="questao"/></td>
            <td>{{ questao.questao }}</td>
            <td style="word-break: break-word;" :title="questao.enunciadoAbreviado">{{ abreviaTexto(questao.enunciadoAbreviado) }}</td>
            <td>{{ questao.professor && questao.professor.professor || '-' }}</td>
            <td>{{ questao.curso && questao.curso.curso || '-' }}</td>
            <td>{{ questao.modulo && questao.modulo.modulo || '-' }}</td>
            <td>{{ questao.licao && questao.licao.licao || '-' }}</td>
            <td>{{ questao.created_at | formatDatetime }}</td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" v-b-tooltip.hover title="Visualizar" @click="visualizarQuestao(questao)"><i class="fas fa-eye"></i></a>
                <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" v-if="verificaEdicaoQuestao(questao)" @click="modalEdicaoQuestao(questao)"><i class="fas fa-edit"></i></a>
                <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" v-if="false"><i class="fas fa-trash-alt"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import ModalCadastroQuestao from '@/modules/Conteudo/components/ModalCadastroQuestao'
import ModalCadastroSimulado from '@/modules/Conteudo/components/ModalCadastroSimulado'
import ModalAssociaQuestao from '@/modules/Conteudo/components/ModalAssociaQuestao'
import ModalImportacaoQuestoes from '@/modules/Conteudo/components/ModalImportacaoQuestoes'
import InfiniteLoading from 'vue-infinite-loading'
import EmpresaUtils from '@/core/util/empresa-utils'
import ProfessorAPI from '@/api/professor-api'
import QuestaoAPI from '@/api/questao-api'
import SimuladoAPI from '@/api/simulado-api'
import ConteudoAPI from '@/api/conteudo-api'
import CursoAPI from '@/api/curso-api'
import ModuloAPI from '@/api/modulo-api'
import LicaoAPI from '@/api/licao-api'
import Swal from 'sweetalert2'
import StringUtils from '@/core/util/string-utils'

export default {
  name: 'ListaQuestoes',
  props: {
    perfil: Object
  },
  components: {
    ModalImportacaoQuestoes,
    ModalCadastroQuestao,
    ModalCadastroSimulado,
    ModalAssociaQuestao,
    InfiniteLoading
  },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      professores: [],
      modalidades: [],
      publicoAlvo: [],
      fontes: [],
      cursos: [],
      modulos: [],
      licoes: [],
      questoes: [],
      tipoSimulados: [],
      questoesSelecionadas: [],
      questaoEdicao: null,
      infiniteId: new Date(),
      scrolled: false,
      shiftPressed: false,
      visualizacao: false,
      filtro: {
        tipo: 1,
        nome: null,
        ano: null,
        professor: '',
        enunciado: '',
        resposta1: '',
        comentario: '',
        curso: '',
        modulo: '',
        licao: ''
      }
    }
  },

  computed: {
    filtroCursos () {
      if (!this.perfil.isAdminJaleko) {
        return {
          empresa_id: EmpresaUtils.getEmpresa().id
        }
      } else {
        return {}
      }
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },

  mounted () {
    ProfessorAPI.listar().then(data => {
      this.professores = data
    })
    ConteudoAPI.listarModalidades().then(data => {
      this.modalidades = data
    })
    ConteudoAPI.listarFontes().then(data => {
      this.fontes = data
    })
    ConteudoAPI.listarPublicos().then(data => {
      this.publicoAlvo = data
    })
    SimuladoAPI.listarTipos().then(data => {
      this.tipoSimulados = data
    })
    CursoAPI.listar(null, this.filtroCursos).then(data => {
      this.cursos = data
    })
    ModuloAPI.listar().then(data => {
      this.modulos = data
    })
    LicaoAPI.listar().then(data => {
      this.licoes = data
    })
  },

  methods: {
    abreviaTexto (texto) {
      if (texto.length > 80) {
        return StringUtils.abreviaString(texto, 80)
      }
      return texto
    },
    verificaEdicaoQuestao (questao) {
      let empresaId = EmpresaUtils.getEmpresa().id
      if ((this.perfil.isAdminJaleko || this.perfil.isAdmin || this.perfil.isEditor) && empresaId === questao.empresa_criadora_id) {
        return true
      }
      if (empresaId === 1) {
        return true
      }
      return false
    },

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    modalCadastrarQuestao: function () {
      this.questaoEdicao = null
      this.visualizacao = false
      this.$nextTick(() => {
        this.$refs.modalCadastroQuestao.show()
      })
    },

    modalCadastrarSimulado: function () {
      if (this.questoesSelecionadas && this.questoesSelecionadas.length >= 1) {
        this.questaoEdicao = null

        this.questoesSelecionadas = this.questoesSelecionadas.slice().sort(function (a, b) {
          return new Date(a.id) - new Date(b.id)
        })

        this.$nextTick(() => {
          this.$refs.modalCadastroSimulado.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais questões para criar um simulado'
        })
      }
    },

    modalAssociarQuestao: function () {
      if (this.questoesSelecionadas && this.questoesSelecionadas.length >= 1) {
        this.questaoEdicao = null

        this.questoesSelecionadas = this.questoesSelecionadas.sort(function (a, b) {
          return new Date(a.id) - new Date(b.id)
        })

        this.$nextTick(() => {
          this.$refs.modalTopicoQuestao.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais questões para associar a uma lição'
        })
      }
    },

    modalImportarQuestoes: function () {
      this.$nextTick(() => {
        this.$refs.modalImportacaoQuestoes.show()
      })
    },

    modalEdicaoQuestao: function (questao) {
      this.questaoEdicao = questao
      this.visualizacao = false
      this.$nextTick(() => {
        this.$refs.modalCadastroQuestao.show()
      })
    },

    visualizarQuestao: function (questao) {
      this.questaoEdicao = questao
      this.visualizacao = true
      this.$nextTick(() => {
        this.$refs.modalCadastroQuestao.show()
      })
    },

    buscarQuestoes: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.questoes = []
      this.questoesSelecionadas = []
    },

    alteraSelecionada: function (questao) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (questao.id > this.ultimoSelecionado.id)
        let novosSelecionados = []
        novosSelecionados = this.questoes.filter(item => {
          if (maiorQueUltimo) {
            return (item.id <= questao.id) && (item.id >= this.ultimoSelecionado.id)
          } else {
            return (item.id <= this.ultimoSelecionado.id) && (item.id >= questao.id)
          }
        })
        novosSelecionados.map(questao => {
          !this.questoesSelecionadas.includes(questao) && this.questoesSelecionadas.push(questao)
        })
      }
      this.ultimoSelecionado = questao
    },

    infiniteHandler: function ($state) {
      QuestaoAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.questoes.push(...data.data.map(item => {
            item.enunciadoAbreviado = item.enunciado && item.enunciado.length > 600 ? item.enunciado.substring(0, 600) + '...' : item.enunciado
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    }
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
